module.exports = __webpack_public_path__ + "img/TElegant.9bfc5678.png";